import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import Home from "../pages/Home";
import About from "../pages/About";
import LinkedInCallback from "../pages/LinkedInCallback";
import JobList from "../pages/JobList";
import JobDetail from "../pages/JobDetail";
import Profil from "../pages/Profil";
import Ozgecmisim from "../pages/Ozgecmisim";
import SinavCoz from "../pages/SinavCoz";
import Anket from "../pages/Anket";
import BenimMenu from "../pages/BenimMenu";
import EgitimStep from "../pages/EgitimStep";
import ShiftYonetimi from "../pages/mudur/ShiftYonetimi";

import Navbar from "../components/Navbar";
import PrivateRoute from "../components/PrivateRoute";
import WelcomeVideoPopup from "./WelcomeVideoPopup";

import { GoogleOAuthProvider } from "@react-oauth/google";
import "../styles/App.css";

const AppContent = () => {
  const location = useLocation();

  const tamEkranSayfaMi =
    location.pathname.startsWith("/personel/sinav/") ||
    location.pathname.startsWith("/personel/anket/") ||
    location.pathname.startsWith("/personel/egitim/") ||
    location.pathname.startsWith("/personel/shift-yonetimi");
  return (
    <>
      {!tamEkranSayfaMi && <Navbar />}
      {!tamEkranSayfaMi && <WelcomeVideoPopup />}

      <Routes>
        {/* Herkese açık sayfalar */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/joblist" element={<JobList />} />
        <Route path="/ilan/:id" element={<JobDetail />} />
        <Route
          path="/linkedin-callback"
          element={<LinkedInCallback />}
        />

        {/* Giriş gerekli sayfalar */}
        <Route
          path="/profil"
          element={
            <PrivateRoute>
              <Profil />
            </PrivateRoute>
          }
        />

        <Route
          path="/ozgecmisim"
          element={
            <PrivateRoute>
              <Ozgecmisim />
            </PrivateRoute>
          }
        />

        <Route
          path="/personel/egitim/:egitimId"
          element={
            <PrivateRoute>
              <EgitimStep />
            </PrivateRoute>
          }
        />
        {/* Sınav sayfası (Navbar YOK) */}
        <Route
          path="/personel/sinav/:kullaniciSinavId"
          element={
            <PrivateRoute>
              <SinavCoz />
            </PrivateRoute>
          }
        />

        {/* Anket sayfası */}
        <Route
          path="/personel/anket/:modulEgitimAnketId"
          element={
            <PrivateRoute>
              <Anket />
            </PrivateRoute>
          }
        />

        <Route
          path="/benim-menu"
          element={
            <PrivateRoute>
              <BenimMenu />
            </PrivateRoute>
          }
        />

        <Route
          path="/personel/shift-yonetimi"
          element={
            <PrivateRoute>
              <ShiftYonetimi />
            </PrivateRoute>
          }
        />

      </Routes>


    </>
  );
};

const App = () => {
  return (
    <GoogleOAuthProvider clientId="137542923351-ecqbv2qo50c50dcoe47cdgmgjr6t9gob.apps.googleusercontent.com">
      <Router>
        <AppContent />
      </Router>
    </GoogleOAuthProvider>
  );
};

export default App;
